const PagePermBits = {
  dashboard: 1, //2^0
  domainManagement: 2, //2^1
  siteManagement: 4, //2^2
  userManagement: 8, //2^3
  reports: 16, //2^4
  setParameters: 32, //2^5
  commit: 64, //2^6
};
export default PagePermBits;